<template>
    <div>
        <Hero />

        <div class="p-8 md:p-20">
            <!-- <div class="text-xl mt-3 flex flex-col gap-y-4">
                <p>Missions is an evangelical outreach scheme birthed from a strong desire to see all men saved.</p>
                <p>During our mission outreaches, we collaborate with Word Outreach Network to visit villages to win souls, heal sick bodies, and set captives free.</p>               
            </div> -->

            <div class="grid lg:grid-cols-2 mt-5 gap-3 place-items-center">
                <div>
                    <!-- <img src="../assets/images/placeholder.jpg" alt="" class="rounded w-full"> -->
                    <div class="text-xl mt-3 flex flex-col gap-y-4">
                        <div class="uppercase font-bold text-xl">About</div>
                        <p>Missions is an evangelical outreach scheme birthed from a strong desire to see all men saved.</p>
                        <p>During our mission outreaches, we collaborate with Word Outreach Network to visit villages to win souls, heal sick bodies, and set captives free.</p>               
                    </div>
                </div>
                <div>
                    <img src="../assets/images/misison2.jpg" alt="" class="w-full rounded">
                </div>
            </div>

            <RouterLink to="/give" class="mt-10 flex justify-center">
                <SecondaryButton content="support the work" />
            </RouterLink>
        </div>

        <BecomeOurFamily/>

        <BottomLinks />
    </div>
</template>

<script setup>
import Hero from '../components/Missions/Hero.vue';
import SecondaryButton from '../components/SecondaryButton.vue'
import BecomeOurFamily from '../components/BecomeOurFamily.vue';
import BottomLinks from '../components/Missions/BottomLinks.vue';
</script>

<style scoped>

</style>